<!-- ═══════════════════════════════════════════════════════════════════════
     FILE: message-popup.component.html
     Die ganze Karte ist die Klickfläche. Ausgenommen: das Kreuz oben rechts
     und die Leiste unten — beide halten den Klick an.
     ═══════════════════════════════════════════════════════════════════ -->

@if (eintrag(); as e) {
  <div class="pop-host" data-testid="msgpop.host">

    <article
      class="pop"
      [attr.data-obligation]="stufe()"
      data-testid="msgpop.card"
      role="dialog"
      aria-live="polite"
      [attr.aria-label]="'Nachricht: ' + anlass()">

      <!-- Farbstreifen: Breite trägt die Verbindlichkeit mit, nicht nur Farbe -->
      <span class="pop__stripe" aria-hidden="true"></span>

      <!-- Schliessen-Kreuz — navigiert nicht -->
      <button
        type="button"
        class="pop__x"
        data-testid="msgpop.x"
        (click)="schliessen($event)"
        aria-label="Nachricht schliessen">×</button>

      <!-- ── Alles hierin führt zur Ursache ─────────────────────────── -->
      <div class="pop__body" (click)="oeffnen()" data-testid="msgpop.body">

        <header class="pop__head">
          <span class="pop__badge" [attr.data-obligation]="stufe()" data-testid="msgpop.badge">
            {{ stufeWort() }}
          </span>
          <span class="pop__anlass" data-testid="msgpop.anlass">{{ anlass() }}</span>
          @if (e.nachricht.from) {
            <span class="pop__from">· {{ e.nachricht.from }}</span>
          }
        </header>

        <!-- ── CFLX: Schlüssel und Aussage ──────────────────────────── -->
        <dl class="pop__cflx" data-testid="msgpop.cflx">
          @for (a of aussagen(); track a.schluessel) {
            <dt class="pop__key" [attr.data-art]="a.art">{{ a.schluessel }}</dt>
            <dd class="pop__val" [attr.data-art]="a.art">{{ a.wert }}</dd>
          }
          @if (aussagen().length === 0) {
            <dd class="pop__val pop__val--leer">Zu diesem Vorgang liegt kein Text vor.</dd>
          }
        </dl>

        <!-- ── Sachbezug ─────────────────────────────────────────────── -->
        <section class="pop__fakten" data-testid="msgpop.fakten">
          @if (e.nachricht.reason) {
            <p class="pop__fakt">
              <span class="pop__faktKey">Warum du das siehst</span>
              <span class="pop__faktVal">{{ e.nachricht.reason }}</span>
            </p>
          }
          <p class="pop__fakt">
            <span class="pop__faktKey">Bezug</span>
            <span class="pop__faktVal">
              {{ ankerTyp() || 'unbekannt' }}
              @if (ankerId() !== null) { <b>#{{ ankerId() }}</b> }
              @if (e.nachricht.pslot) { <span class="pop__pslot">· {{ e.nachricht.pslot }}</span> }
            </span>
          </p>
        </section>

        <!-- ── Zwei Zeiten, beide UTC ────────────────────────────────── -->
        <section class="pop__zeit" data-testid="msgpop.zeit">
          <p class="pop__zeitZeile">
            <span class="pop__zeitKey">Ereignis</span>
            <span class="pop__zeitVal" data-testid="msgpop.utc-ereignis">{{ utc(e.nachricht.utc) }}</span>
            <span class="pop__zeitAlt">{{ alter(e.nachricht.utc) }}</span>
          </p>
          <p class="pop__zeitZeile">
            <span class="pop__zeitKey">Angezeigt</span>
            <span class="pop__zeitVal" data-testid="msgpop.utc-gezeigt">{{ utc(e.gezeigtUtc) }}</span>
          </p>
        </section>

        <p class="pop__hinweis" data-testid="msgpop.hinweis">{{ zielWort() }} →</p>
      </div>

      <!-- ── Leiste unten — navigiert nicht ─────────────────────────── -->
      <footer class="pop__foot">
        @if (wartend() > 0) {
          <button
            type="button"
            class="pop__mehr"
            data-testid="msgpop.mehr"
            (click)="alleVerwerfen($event)"
            [attr.title]="'Die wartenden Nachrichten bleiben im Posteingang'">
            +{{ wartend() }} weitere · alle verwerfen
          </button>
        } @else {
          <span class="pop__mehr pop__mehr--leer">keine weitere</span>
        }

        <button
          type="button"
          class="pop__close"
          data-testid="msgpop.close"
          (click)="schliessen($event)">Schliessen</button>
      </footer>

    </article>
  </div>
}
